import React from "react"; // You can create a CSS file for custom styling if needed

const GalleryForEmergency = () => {
  const images = [
    "/assets/images/admin_1.jpg",
    "/assets/images/admin_2.jpg",
    "/assets/images/admin_3.jpg",
    "/assets/images/admin_4.jpg",
    "/assets/images/admin_5.jpg",
    "/assets/images/admin_6.jpg",
    "/assets/images/admin_7.jpg",
    "/assets/images/admin_8.jpg",
    "/assets/images/admin_9.jpg",
    "/assets/images/admin_10.jpg",
    "/assets/images/admin_11.jpg",
    "/assets/images/admin_12.jpg",
  ];
  return (
    <div className="my-5 shadow bg-body rounded p-4">
      <h4 className="text-start">EMERGENCY MEDICINE</h4>
      <p className="text-start mb-4">
        The Emergency Medicine Department of United Hospital is a 24-hour, full
        time section and it is the mirror of United Hospital. It offers the
        highest degree of commitment to delivering quality and efficient
        emergency care. Prompt and rapid response of our skilled medical
        personnel defines our Emergency Medicine Unit. This is where very
        critically ill and injured patients are received and managed.
      </p>
      <div className="row">
        {images.map((items, index) => (
          <div className="col-md-3 col-sm-6 mb-3">
            <img src={items} alt="Image 1" className="img-fluid" />
          </div>
        ))}
        {/* <div className="col-md-4 col-sm-6 mb-3">
          <img src="image1.jpg" alt="Image 1" className="img-fluid" />
        </div>
        <div className="col-md-4 col-sm-6 mb-3">
          <img src="image2.jpg" alt="Image 2" className="img-fluid" />
        </div>
        <div className="col-md-4 col-sm-6 mb-3">
          <img src="image3.jpg" alt="Image 3" className="img-fluid" />
        </div>
        <div className="col-md-4 col-sm-6 mb-3">
          <img src="image4.jpg" alt="Image 4" className="img-fluid" />
        </div>
        <div className="col-md-4 col-sm-6 mb-3">
          <img src="image5.jpg" alt="Image 5" className="img-fluid" />
        </div>
        <div className="col-md-4 col-sm-6 mb-3">
          <img src="image6.jpg" alt="Image 6" className="img-fluid" />
        </div> */}
      </div>
    </div>
  );
};

export default GalleryForEmergency;



// WEBPACK FOOTER //
// ./src/component/frontend/GalleryForEmergency.js